// extracted by mini-css-extract-plugin
export default {"mobile":"People_mobile__r6lE2","desktop":"People_desktop__xwfHP"};